'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sponsor = exports.headerContent = exports.headerLogo = exports.promotionContent = exports.caption = exports.text = exports.markup = exports.tag = exports.story = exports.links = exports.section = exports.originator = exports.contact = exports.videoAsset = exports.imageAsset = exports.imageUrl = exports.imageSize = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// --- Image Asset ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#image-size
var imageSize = exports.imageSize = _propTypes2.default.shape({
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired
});

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#image-url
var imageUrl = exports.imageUrl = _propTypes2.default.shape({
    url: _propTypes2.default.string.isRequired,
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number
});

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#image-asset
var imageAsset = exports.imageAsset = _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    size: imageSize,
    urls: _propTypes2.default.arrayOf(imageUrl).isRequired
});

// --- Video Asset ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#video-asset
var videoAsset = exports.videoAsset = _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    duration: _propTypes2.default.number
});

// --- Originator ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#contact
var contact = exports.contact = _propTypes2.default.shape({
    type: _propTypes2.default.oneOf(['email', 'web', 'twitter', 'facebook', 'phone']).isRequired,
    value: _propTypes2.default.string.isRequired
});

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#originator
var originator = exports.originator = _propTypes2.default.shape({
    id: _propTypes2.default.string,
    title: _propTypes2.default.string.isRequired,
    contacts: _propTypes2.default.arrayOf(contact),
    description: _propTypes2.default.string,
    image: _propTypes2.default.string,
    imageAsset: imageAsset
});

// --- Section ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#section
var section = exports.section = _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string.isRequired,
    statisticsName: _propTypes2.default.string,
    enabled: _propTypes2.default.bool
});

// --- Links ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#links
var links = exports.links = _propTypes2.default.shape({
    shareUrl: _propTypes2.default.string.isRequired,
    canonicalUrl: _propTypes2.default.string.isRequired
});

// --- Story ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#story
var story = exports.story = _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired,
    updated: _propTypes2.default.string.isRequired,
    description: _propTypes2.default.string,
    enabled: _propTypes2.default.bool
});

// --- Tag ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#tag
var tag = exports.tag = _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.oneOf(['descriptor', 'organization', 'person', 'place', 'location'])
});

// --- Text ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#markup
var markup = exports.markup = _propTypes2.default.shape({
    type: _propTypes2.default.string.isRequired,
    uri: _propTypes2.default.string,
    offset: _propTypes2.default.number.isRequired,
    length: _propTypes2.default.number.isRequired
});

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#text
var text = exports.text = _propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    markup: _propTypes2.default.arrayOf(markup)
});

var caption = exports.caption = text;

// --- Promotion Content ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#promotion-content
var promotionContent = exports.promotionContent = _propTypes2.default.shape({
    title: text.isRequired,
    description: text,
    imageAsset: imageAsset
});

// --- Header Logo ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#header-logo
var headerLogo = exports.headerLogo = _propTypes2.default.shape({
    imageAsset: imageAsset.isRequired,
    url: _propTypes2.default.string.isRequired
});

// --- Header Content ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#header-content
var headerContent = exports.headerContent = _propTypes2.default.shape({
    logo: headerLogo.isRequired,
    showWeather: _propTypes2.default.bool,
    showUserMenu: _propTypes2.default.bool
});

// --- Sponsor ---

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#sponsor
var sponsor = exports.sponsor = _propTypes2.default.shape({
    logo: imageAsset.isRequired,
    title: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string.isRequired
});
//# sourceMappingURL=objects.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/inline-video/~/@spp/iris-prop-types/lib/cjs/objects.js
 ** module id = 276
 ** module chunks = 1
 **/